import React, { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import Form from 'react-bootstrap/Form';
import { useDropzone } from 'react-dropzone';
import { RadioButton } from "primereact/radiobutton";

//icons
import BlackGallery from '../../assets/icons/black-gallery.svg'
import Gallery from '../../assets/icons/gallery.svg'
import Video from '../../assets/icons/video.svg'
import BlackVideo from '../../assets/icons/black-video.svg'
import Upload from '../../assets/icons/upload.svg'
import Trash from '../../assets/icons/trash.svg'
import Img from '../../assets/images/image.jfif'
import Loader from '../loader/loader'

import { baseUrl, CreateCompany, DeleteCompany, SearchCompany } from '../../utils/api';
import { confirmDialog, ConfirmDialog } from 'primereact/confirmdialog';
import useToastNotification from '../../hooks/useToastNotification';
import { getRawBase64Data, toBase64 } from '../../utils/image';

function Companies() {
    const { showError, showSuccess } = useToastNotification();
    const [visibleImageUpload, setVisibleImageUpload] = useState(false)
    const [uploadedFile, setUploadedFile] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);
    const [uploadStatus, setUploadStatus] = useState(null);
    const [defaultImg, setDefaultImg] = useState('');

    const [items, setItems] = useState([]);
    useEffect(() => {
        loadPage();
    }, []);
    const loadPage = async () => {
        try {
            SearchCompany({}).then(response => {
                setItems(response.data?.data?.items);
            })
        } catch (error) {}
    };

    const { getRootProps, getInputProps } = useDropzone({
        onDrop: (acceptedFiles) => {
            const file = acceptedFiles[0];
            setUploadedFile(file);

            // Clear previews
            setImagePreview(null);

            // Check if the file is an image or video
            if (file.type.startsWith('image/')) {
                const reader = new FileReader();
                reader.onloadend = () => {
                    setImagePreview(reader.result); // Set image preview
                };
                reader.readAsDataURL(file);
            }
        },
        accept: 'image/*',  // Accept both images and videos
        maxFiles: 1
    });

    // Function to handle the file upload
    const handleFileUpload = (file) => {
        const formData = new FormData();
        formData.append('file', file);

        // Simulate a file upload process (replace with your API)
        fetch('https://example.com/upload', {
            method: 'POST',
            body: formData,
        })
            .then(response => response.json())
            .then(data => {
                setUploadStatus('Upload successful!');
                console.log('Success:', data);
            })
            .catch(error => {
                setUploadStatus('Upload failed!');
                console.error('Error:', error);
            });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        let data = {
            fileBase64: await getRawBase64Data(uploadedFile),
            title: "Company",
        };
        setLoading(true);
        await CreateCompany(data).then(response => {
            showSuccess("عملیات موفقیت آمیز");
            closeAddDialog();
            loadPage();
        })
        .catch(error => {showError(error.response.data.message || 'خطایی رخ داد')})
        .finally(() => {
            setLoading(false);
        });
    };

    const [loading, setLoading] = useState(false);
    const [addVisible, setAddVisible] = useState(false);

    const openAddDialog = () => {
        setLoading(false);
        setUploadStatus("");
        setAddVisible(true);
        document.body.style.overflow = 'hidden'; // غیرفعال کردن اسکرول

    };
    const closeAddDialog = (forceClose = false) => {
        if (loading === true && forceClose !== true) return;
        setUploadStatus("");
        setAddVisible(false);
        document.body.style.overflow = 'auto'; // فعال کردن مجدد اسکرول

        // reset properties to default
        setImagePreview(null);
        setUploadedFile(null);
    };

    const deleteItem = async (item) => {
        await DeleteCompany({ id: item.id }).then(() => {
            showSuccess("عملیات با موفقیت انجام شد");
            setItems(old => old.filter(filter => item.id !== filter.id));
        }).catch(error => {
            showError(error.response.data.message);
        });
    };
    const openDeleteDialog = async (rowData) => {
        document.body.style.overflow = 'hidden'; // غیرفعال کردن اسکرول

        confirmDialog({
            message: 'آیا از حذف آیتم اطمینان دارید؟',
            header: 'حذف آیتم',
            defaultFocus: 'reject',
            maskClassName: 'flex',
            headerClassName: '!pr-1 !pl-1',
            acceptClassName: 'btn btn-danger mx-1',
            rejectClassName: 'btn btn-secondary mx-1',
            acceptLabel: 'حذف',
            rejectLabel: 'انصراف',
            resizable: false,
            accept: () => {deleteItem(rowData)
                document.body.style.overflow = 'auto'; 
            },
            reject: () => { document.body.style.overflow = 'auto'; // فعال کردن مجدد اسکرول
            },
        });
    };

    return (
        <>
                    <label className="mb-2">تصویر لوگو مجموعه را وارد کنید.</label>

            <div className='d-flex align-items-center justify-content-start gap-3'>
                <div >
                    <div className='upload-file-btn' onClick={openAddDialog}>
                        <img src={Gallery} alt="" />
                        <h6 className='fw-500 text-[#669D24] text-sm'>انتشار تصویر</h6>
                    </div>

                </div>


            </div>
            <hr />
            <div className='list-defult'>
                <h6 className='fw-500 d-flex align-items-center gap-2'>مشتریان بن آیس</h6>

                <div className='d-flex align-items-center gap-2 mt-4' style={{ flexWrap: 'wrap' }}>
                    {items.map(item =>
                        <div className='upload-file-btn' title={item.title}>
                            <img src={baseUrl + "io/112x112/" + item.logoPath} alt="Uploaded preview" className="image-preview" />
                            <div className='upload-file-btn-bottom justify-content-center' onClick={() => openDeleteDialog(item)} >
                                <div>
                                    <img src={Trash} alt="" />
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>


            {/* upload image  */}
            <Dialog header="انتشار تصویر" visible={addVisible} maximizable style={{ width: '40vw' }} onHide={() => { if (!addVisible) return; closeAddDialog(); }}>
                <div className='dialog-body mx-4'>
                    <Form className='mt-3' onSubmit={handleSubmit}>

                        <div {...getRootProps()} className="upload-box">
                            <input {...getInputProps()} accept='image/*' max={1} multiple={false} />
                            {
                                imagePreview ? (
                                    <img src={imagePreview} alt="Uploaded preview" className="image-preview" />
                                ) : (
                                    <div>
                                        <img src={Upload} alt="" className='mx-auto' />
                                        <p className='text-xs mt-2 font-medium'>تصویر مورد نظر را از این قسمت وارد کنید</p>
                                        <h6 className='text-[10px]'>بهترین ابعاد: 100 * 100</h6>
                                        <h6 className='text-[10px]'>ماکزیمم حجم تصویر: ...</h6>
                                    </div>
                                )
                            }
                        </div>

                        {uploadStatus && <p className="upload-status">{uploadStatus}</p>}

                        <button type="submit" disabled={loading} className="btn btn-primary w-100 mt-4">تایید و ثبت {loading && <Loader />}</button>
                    </Form>
                </div>
            </Dialog>

        </>
    )
}
export default Companies;
